<template lang="html">
  <div class="exam-result-component">
    <v-container>
      <v-expansion-panels v-model="active_panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="subtitle-1">Kötelezettségek</v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-divider></v-divider>
      <v-row>
        <v-col cols="6" md="3">
         <v-checkbox v-model="no_exam" value="1" class="mx-2" label="Nem vizsgázhat"></v-checkbox>
         <span>{{no_exam_creator}}</span>
       </v-col>
       <v-col cols="6" md="4">
        <v-text-field
          v-model="no_exam_desc"
          label="Megjegyzés"
          outlined
        ></v-text-field>
       </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" md="3">
         <v-checkbox v-model="exam_fee" value="2" class="mx-2" label="Vizsgadíj"></v-checkbox>
         <span>{{exam_fee_creator}}</span>
       </v-col>
       <v-col cols="6" md="4">
        <v-text-field
          v-model="exam_fee_desc"
          label="Megjegyzés"
          outlined
        ></v-text-field>
       </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" md="3">
         <v-checkbox v-model="med_cert" value="3" class="mx-2" label="Orvosi alkalmassági"></v-checkbox>
         <span>{{med_cert_creator}}</span>
       </v-col>
       <v-col cols="6" md="4">
         <v-select
           v-model="med_cert_lookup"
           :items="oblookup"
           item-text="name"
           item-value="oblookup_id"
           label="Megjegyzés"
           outlined
         ></v-select>
       </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" md="3">
         <v-checkbox v-model="license" value="4" class="mx-2" label="Jogsi/végzettség"></v-checkbox>
         <span>{{license_creator}}</span>
       </v-col>
       <v-col cols="6" md="4">
        <v-text-field
          v-model="license_desc"
          label="Megjegyzés"
          outlined
        ></v-text-field>
       </v-col>
      </v-row>
      <v-row>
        <v-col>
        <v-btn @click="saveExamObligatory" rounded color="primary" dark>Mentés</v-btn>
        </v-col>
      </v-row>
      </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="subtitle-1">KAV vizsgaeredmények</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-progress-linear
            v-if="kav_ex_loading"
            indeterminate
            color="red"
          ></v-progress-linear>
            <v-data-table
              v-if="!kav_ex_loading && kokeny_exams != ''"
              :headers="exam_headers"
              :items="kokeny_exams"
              :items-per-page="15"
            >
            <template v-slot:item.felszab="{ item }">
              <v-btn v-if="item.VizsgaEredmeny == 'Utólag igazolt orvosi igazolás alapján'" @click="getVdPayments(item)" outlined color="green">
                Vizsgadíj felszab.
              </v-btn>
            </template>  
        </v-data-table>
                        <v-row>
                          <v-col cols="12" md="4" class="mt-2">
                            <v-btn @click="exam_del_dialog=true, getStudIds()" outlined color="red">
                              Vizsgaidőpont lemondás
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="4" class="mt-2">
                            <v-btn @click="exam_vertif_dialog=true, getStudIds()" outlined color="green">
                              Hiányzás igazolás
                            </v-btn>
                          </v-col>
                        </v-row>
          <v-dialog
            v-model="exam_del_dialog"
            persistent
            width="600"
          >
            <v-card>
              <v-card-title class="text-h5">
                Igényelt vizsgaidőpontok
              </v-card-title>
              <v-container>
                          <v-radio-group v-model="del_exam_picked" row>
                            <v-radio label="Elmélet" color="#FF9800" value="Elmelet"></v-radio>
                            <v-radio label="Gyakorlat" color="#FF9800" value="Gyakorlat" ></v-radio>
                          </v-radio-group>
                  <v-combobox
                    v-model="selected_stud_id"
                    :items="stud_ids"
                    item-text="course_student_id"
                    label="Tanuló azonosító"
                    outlined
                  ></v-combobox>
                      <v-progress-linear
                        v-if="del_exam_loader"
                        indeterminate
                        color="pink"
                      ></v-progress-linear>
                  <v-data-table
                    v-model="selected_exam_to_del"
                    v-if="exams_to_del != ''"
                    :headers="exams_del_headers"
                    :items="exams_to_del"
                    :items-per-page="15"
                    show-select
                    single-select
                  ></v-data-table>
              </v-container>
              <v-card-actions>
                <v-btn
                  outlined
                  color="green"
                  variant="text"
                  @click="exam_del_dialog = false"
                >
                  mégsem
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                :disabled="selected_exam_to_del == '' || del_exam_button_loader"
                outlined
                  color="red"
                  variant="text"
                  @click="gyakExamDeadlineCheck()"
                  :loading="del_exam_button_loader"
                >
                  kijelöltek lemondása
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="exam_vertif_dialog"
            persistent
            width="600"
          >
            <v-card>
              <v-card-title class="text-h5">
                Hiányzás igazolása
              </v-card-title>
              <v-container>
                  <v-combobox
                    v-model="selected_stud_id"
                    :items="stud_ids"
                    item-text="course_student_id"
                    label="Tanuló azonosító"
                    outlined
                  ></v-combobox>
                      <v-progress-linear
                        v-if="vertif_exam_loader"
                        indeterminate
                        color="pink"
                      ></v-progress-linear>
                  <v-form
                    ref="valid_form"
                    v-model="vertif_valid"
                    
                  >
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            v-model="verfit_start_date"
                            label="Kezdő dátum"
                            append-icon="mdi-calendar"
                            readonly
                            :rules="rules"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="verfit_start_date"
                          first-day-of-week="1"
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            v-model="verfit_end_date"
                            label="Befejező dátum"
                            append-icon="mdi-calendar"
                            readonly
                            :rules="rules"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="verfit_end_date"
                          @input="menu2 = false"
                          first-day-of-week="1"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    </v-row>
                    <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        outlined
                        v-model="verfit_number"
                        label="Igazolás sorszáma"
                        :rules="rules"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-file-input
                        v-model="medVertif_to_upload"
                        outlined
                        accept=".pdf"
                        label="Orvosi igazolás"
                        :rules="rules"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                  </v-form>
                  <v-data-table
                    v-model="selected_exam_to_vertif"
                    v-if="exams_to_vertif != ''"
                    :headers="exams_vertif_headers"
                    :items="exams_to_vertif"
                    :items-per-page="15"
                    item-key="VizsgaId"
                    show-select
                    single-select
                  ></v-data-table>
              </v-container>
              <v-card-actions>
                <v-btn
                  outlined
                  color="red"
                  variant="text"
                  @click="exam_vertif_dialog = false"
                >
                  mégsem
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="selected_exam_to_vertif == '' || !vertif_valid || vertif_uploading"
                  :loading="vertif_uploading"
                  outlined
                  color="green"
                  @click="uploadExamstoVertif()"
                >
                  igazolás beküldés
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

            <v-dialog
              v-model="exam_del_confirm_dialog"
              persistent
              max-width="600"
            >
              <v-card>
                <v-card-title class="text-h5">
                  Biztosan lemondja a kiválasztott vizsgát?
                </v-card-title>
                <v-card-text>
                  Tanuló: <b>{{nevToDel}}</b><br>
                  Időpont: <b>{{idopontToDel}}</b><br>
                  Helyszín: <b>{{helyszinToDel}}</b><br>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red"
                    text
                    @click="exam_del_confirm_dialog = false"
                  >
                    Nem
                  </v-btn>
                  <v-btn
                    color="green"
                    text
                    @click="dalExams()"
                    :loading="del_exam_button_loader"
                    :disabled="del_exam_button_loader"
                  >
                    Igen
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
            v-model="free_vd_dialog"
            persistent
            width="800"
            >
            <v-card>
              <v-card-title class="text-h5">
                Felhasznált vizsgadíjak
              </v-card-title>
              <v-container>
                  <v-data-table
                    v-model="selected_vd_to_free"
                    :headers="paymentsToFree_headers"
                    :items="vdPaymentsToFree"
                    :items-per-page="15"
                    item-key="payment_id"
                    show-select
                    single-select
                  ></v-data-table>
              </v-container>
              <v-card-actions>
                <v-btn
                  outlined
                  color="green"
                  variant="text"
                  @click="free_vd_dialog = false"
                >
                  mégsem
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                :disabled="selected_vd_to_free == '' || !selected_vd_to_free || del_exam_button_loader"
                outlined
                  color="red"
                  variant="text"
                  :loading="del_exam_button_loader"
                  @click="freeVdFromExams()"
                >
                  kijelölt felszabadítása
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

      </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="subtitle-1">Vizsgaidőpont archívum</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-progress-linear
            v-if="ex_res_loading"
            indeterminate
            color="red"
          ></v-progress-linear>
              <v-data-table
              v-model="selected_csiga_exam_to_del"
              v-if="!ex_res_loading && student_exam_result != ''"
              :headers="headers"
              :items="student_exam_result"
              :items-per-page="15"
              @click:row="modExamResult($event)"
              show-select
              item-key="exam_data_id"
              single-select
            ></v-data-table>
                <v-row>
                   <v-col cols="12" md="2" class="mt-2">
                      <v-btn @click="delOldExams()" outlined color="red" :disabled="selected_csiga_exam_to_del == ''">
                          Törlés
                   </v-btn>
                   </v-col>
              </v-row>
            Bizonyítványt bemutatta: <b>{{ bizonyitvany }}</b>
            <br>
            Nyilatkozat: <b>{{ nyilatkozat }}</b>
            <div v-if="course_type == 3 || admin">
            <br>
            <div class="subtitle-1">Kézi eredmény rögzítés</div>
            <v-divider></v-divider>
            <v-form
              ref="save_exam_form"
              v-model="valid"
            >
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="vib_ikt"
                  label="VIB iktató"
                  v-mask="'A#############'"
                  :rules="rules"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="exam_date"
                label="Vizsga dátum"
                v-mask="'####.##.##'"
                :rules="dateRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="exam_time"
                label="Vizsga időpontja"
                v-mask="'##:##'"
                :rules="timeRules"
              ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="exam_place"
              label="Vizsga helyszíne"
            ></v-text-field>
          </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="exam_type"
                :items="exam_types"
                label="Vizsga típusa"
                item-text="vizsga_targy"
                :rules="rules"
              ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              v-model="exam_result"
              :items="exam_result_types"
              label="Vizsga eredménye"
              item-text="eredmeny"
              :rules="rules"
            ></v-select>
          </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                class="mr-4"
                rounded
                @click="saveExamResult"
                :disabled="!valid"
              >
              Mentés
              </v-btn>
            </v-col>
          </v-row>
          </v-form>
          </div>
      </v-expansion-panel-content>
      </v-expansion-panel>
      </v-expansion-panels>

  </v-container>
  <v-snackbar
  v-model="snackbar"
  >
    {{ response_text }}
    <v-btn
      color="pink"
      text
      @click="snackbar = false"
    >
      Bezár
    </v-btn>
  </v-snackbar>
  </div>
</template>

<script>
import store from '../store'
import {mapFields} from 'vuex-map-fields'

  export default {
    data () {
      return {
        loading: false,
        ex_res_loading: false,
        no_exam_creator: '',
        no_exam: null,
        no_exam_desc: '',
        exam_fee_creator: '',
        exam_fee: null,
        exam_fee_desc: '',
        med_cert_creator: '',
        med_cert: null,
        med_cert_lookup: '',
        med_cert_desc: '',
        license_creator: '',
        license: null,
        license_desc: '',
        oblookup: [],
        exam_obligatories: [],
        no_exam_id: '',
        exam_fee_id: '',
        med_cert_id: '',
        license_id: '',
        response_text: '',
        snackbar: false,
        exam_types: [],
        exam_result_types: [],
        vib_ikt: '',
        exam_date: '',
        exam_time: '',
        exam_place: '',
        exam_type: '',
        exam_result: '',
        valid: true,
        rules: [
          v => !!v || 'kötelező mező',
        ],
        timeRules: [
          v => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || 'Hibás idő formátum!',
        ],
        dateRules: [
          v => !!v || 'Kötelező mező!',
          v => /^\d{4}.(0[1-9]|1[0-2]).(0[1-9]|[12][0-9]|3[01])$/.test(v) || 'Hibás dátum formátum!',
        ],
        headers: [
          { text: 'Vizsgajelentő', value: 'nkh_gui_id' },
          { text: 'Vizsga ideje', value: 'exam_time', width: "150"},
          { text: 'Vizsgázó neve', value: 'student_name', width: "180"},
          { text: 'Tanuló azonosító', value: 'course_student_id' },
          { text: 'Iktatószám', value: 'reg_num' },
          { text: 'Kiírás típusa', value: 'reason' },
          { text: 'Státusz', value: 'label' },
          { text: 'Eredmény', value: 'result' },
          { text: 'Kategória', value: 'subject' },
          { text: 'Vizsga helye', value: 'location', width: "120" },
          { text: 'Vizsgahely azonosító', value: 'office_location', width: "180" },
        ],
        exam_headers: [
          { text: 'Vizsgaidőpont', value: 'idopont' },
          { text: 'Tantárgy', value: 'VizsgatargyMegnevezes' },
          { text: 'Eredmény', value: 'VizsgaEredmeny' },
          { text: '', value: 'felszab' },
        ],
        exam_result_id: '',
        bizonyitvany: '',
        nyilatkozat: '',
        kokeny_exams: [],
        active_panel: 1,
        kav_ex_loading: false,
        exam_del_dialog: false,
        del_exam_picked: 'Elmelet',
        stud_ids: [],
        selected_stud_id: '',
        exams_to_del: [],
        exams_del_headers: [
          { text: 'Vizsgaidőpont', value: 'Idopont' },
          { text: 'Helyszín', value: 'VizsgahelyszinMegnevezes' },
          { text: 'Név', value: 'TanuloNev' },
        ],
        selected_exam_to_del: [],
        del_exam_loader: false,
        del_exam_button_loader: false,
        exam_del_confirm_dialog: false,
        nevToDel: '',
        idopontToDel: '',
        helyszinToDel: '',
        selected_csiga_exam_to_del: [],
        exam_vertif_dialog: false,
        exams_to_vertif: [],
        exams_vertif_headers: [
          { text: 'Vizsgaidőpont', value: 'VizsgaDatum' },
          { text: 'Tárgy', value: 'VizsgatargyMegnevezes' },
        ],
        selected_exam_to_vertif: [],
        vertif_exam_loader: false,
        verfit_start_date: '',
        verfit_end_date: '',
        verfit_number: '',
        menu1: false,
        menu2: false,
        medVertif_to_upload: null,
        vertif_valid: true,
        vertif_uploading: false,
        examToFreeVd: [],
        free_vd_dialog: false,
        vdPaymentsToFree: [],
        selected_vd_to_free: [],
        paymentsToFree_headers: [
          { text: 'Összeg', value: 'amount' },
          { text: 'Megnevezés', value: 'item_name' },
          { text: 'Fizetési mód', value: 'payment_type' },
          { text: 'Számla száma', value: 'invoice_number' },
          { text: 'Felhasználás ideje', value: 'used' },
        ],
      }
    },
    methods: {
      getExamResult: async function() {
        //this.resetValidation()
        this.vib_ikt = null
        this.exam_date = null
        this.exam_time = null
        this.exam_place = null
        this.exam_type = null
        this.exam_result = null
        this.ex_res_loading = true
        this.exam_result_id = null
        await this.gettoken()
        this.$http.post('/diakok/exam_result_20210211', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.ex_res_loading = false
          this.student_exam_result = response.data
          this.resetValidation ()
        }, (error) => {
          console.log(error.data);
        })
      }, 
      getKokenyExamResults: async function() {
        this.kokeny_exams = null;
        this.kav_ex_loading = true;
        await this.gettoken()
        this.$http.post('/kokeny/exam_results', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.kav_ex_loading = false;
          this.kokeny_exams = response.data
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      getVdPayments: async function(item) {
        this.selected_vd_to_free = [];
        this.examToFreeVd = item;
        await this.gettoken()
        this.$http.post('/diakok/diakok_befizetes_to_free', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          console.log(response.data);
          this.vdPaymentsToFree = response.data;
          this.free_vd_dialog = true;
        }, (error) => {
          console.log(error.data);
        })
      },
      freeVdFromExams: async function() {
        this.del_exam_button_loader = true;
        await this.gettoken()
        this.$http.post('/kokeny/freeVdFromExams', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.selected_vd_to_free,
          examToFreeVd: this.examToFreeVd
        }).then((response) => {
          this.del_exam_button_loader = false;
          this.free_vd_dialog = false;
          this.response_text = response.data;
          this.snackbar = true;
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
          this.del_exam_button_loader = false;
        })
      },
      getStudIds: async function() {
        this.exams_to_del = [];
        this.exams_to_vertif = [];
        this.selected_exam_to_vertif = [];
        this.selected_stud_id = null;
        //this.selected_stud_id_vertif = null;
        this.stud_ids = null;
        await this.gettoken()
        this.$http.post('/kokeny/stud_ids', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
            this.stud_ids = response.data['ids'];
            this.stud_ids_length = this.stud_ids.length;
            if (this.stud_ids_length == 1) {
                this.selected_stud_id = this.stud_ids[0]; 
            }
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      gyakExamDeadlineCheck() {
        let str_date = this.selected_exam_to_del[0]['Idopont'];
        let deadline_date = new Date(str_date);
        deadline_date.setDate(deadline_date.getDate() - 8);
        deadline_date = deadline_date.toISOString().slice(0, 10);
        let today = new Date().toISOString().slice(0, 10);
        if (today > deadline_date && !this.admin) {
          alert("A módosítási határidő lejárt (8 nap), a kiválasztott vizsga már nem mondható le!");
        } else {
          this.delExamConfirm();
        }
      },
      delExamConfirm() {
        this.exam_del_confirm_dialog = true;
        this.nevToDel = this.selected_exam_to_del[0]['TanuloNev'];
        this.idopontToDel = this.selected_exam_to_del[0]['Idopont'];
        this.helyszinToDel = this.selected_exam_to_del[0]['VizsgahelyszinMegnevezes'];
      },
      getExamstoDel: async function() {
        this.del_exam_loader = true;
        this.stud_ids = null;
        this.selected_exam_to_del = [];
        await this.gettoken()
        this.$http.post('/kokeny/exam_to_del', {
          token: this.token,
          stud_id: this.selected_stud_id,
          del_exam_picked: this.del_exam_picked,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.del_exam_loader = false;
          this.exams_to_del = response.data;
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      getExamstoVertif: async function() {
        this.vertif_exam_loader = true;
        this.stud_ids = null;
        this.exams_to_vertif = [];
        this.selected_exam_to_vertif = [];
        this.verfit_start_date = '',
        this.verfit_end_date = '',
        this.verfit_number = '',
        this.medVertif_to_upload = null,
        this.resetVertifForm()
        await this.gettoken()
        this.$http.post('/kokeny/exams_to_vertif_240725', {
          token: this.token,
          stud_id: this.selected_stud_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.exams_to_vertif = response.data;
          this.vertif_exam_loader = false;
          console.log(response.data);
        }, (error) => {
          this.vertif_exam_loader = false;
          console.log(error.data);
        })
      },
      uploadExamstoVertif: async function() {
        this.vertif_uploading = true
        // objektummá alakítjuk, mert a funkció több fájl feltöltésére lett írva alapvetően
        this.medVertif_to_upload = [this.medVertif_to_upload];

        let formData = new FormData();

        for( var i = 0; i < this.medVertif_to_upload.length; i++ ){
          let file = this.medVertif_to_upload[i];
          formData.append('files[' + i + ']', file);
        }

        this.selected_exam_to_vertif.forEach(element => {
          formData.append("OrvosiIgazolasndex", element.OrvosiIgazolasndex);
          formData.append("VizsgaId", element.VizsgaId);
          formData.append("Id", element.Id);
          formData.append("UgyId", element.UgyId);
          formData.append("JegyzokonyvAzonosito", element.JegyzokonyvAzonosito);
          formData.append("VizsgaDatum", element.VizsgaDatum);
          formData.append("VizsgatargyKod", element.VizsgatargyKod);
          formData.append("VizsgatargyMegnevezes", element.VizsgatargyMegnevezes);
          formData.append("RequestVerificationToken", element.RequestVerificationToken);
        });

        formData.append('token', this.token);
        formData.append('contract_id', this.contract_id);
        formData.append('customer_id', this.customer_id);
        formData.append('stud_id', this.selected_stud_id);
        formData.append('verfit_number', this.verfit_number);
        formData.append('verfit_end_date', this.verfit_end_date);
        formData.append('verfit_start_date', this.verfit_start_date);
        
        await this.gettoken()
        this.$http.post('/kokeny/exams_to_vertif_upload_240725',
          formData,
					{
						headers: {
								'Content-Type': 'multipart/form-data'
						}
					}).then((response) => {
            this.exam_vertif_dialog = false
            this.response_text = response.data;
            this.snackbar = true
            this.vertif_uploading = false
            this.verfit_start_date = ''
            this.verfit_end_date = ''
            this.verfit_number = ''
            this.medVertif_to_upload = null
        }, (error) => {
          this.vertif_uploading = false
          console.log(error.data);
        })
        
      },
      dalExams: async function() {
        this.del_exam_button_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/exam_del_250428', {
          token: this.token,
          selected_exam_to_del: this.selected_exam_to_del,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          stud_id: this.selected_stud_id
        }).then((response) => {
          this.exam_del_confirm_dialog = false
          this.exam_del_dialog = false;
          this.del_exam_button_loader = false
          this.response_text = response.data;
          this.snackbar = true;
          this.getKokenyExamResults();
          this.getExamstoDel();
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      delOldExams: async function() {
        this.del_exam_button_loader = true
        await this.gettoken()
        this.$http.post('/vizsgak/vizsga_delete_students_20210721', {
          token: this.token,
          id: this.selected_csiga_exam_to_del[0]['exam_data_id'],
        }).then((response) => {
          this.del_exam_button_loader = false
          this.response_text = response.data;
          this.snackbar = true;
          this.getExamResult()
          this.selected_csiga_exam_to_del = []
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      getBiziResult: async function() {
        this.bizonyitvany = null;
        this.nyilatkozat = null;
        await this.gettoken()
        this.$http.post('/diakok/exam_result_bizi', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          console.log(response.data);
          this.bizonyitvany = response.data[0]['bizonyitvany'];
          this.nyilatkozat = response.data[0]['nyilatkozat'];
          //this.student_bizi_result = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      saveExamResult: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/save_exam_result_20210211', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          vib_ikt: this.vib_ikt,
          exam_date: this.exam_date,
          exam_time: this.exam_time,
          exam_place: this.exam_place,
          exam_type: this.exam_type,
          exam_result: this.exam_result,
          exam_result_id: this.exam_result_id
        }).then((response) => {
          this.vib_ikt = null
          this.exam_date = null
          this.exam_time = null
          this.exam_place = null
          this.exam_type = null
          this.exam_result = null
          this.preloader = false
          this.response_text = response.data
          this.snackbar = true
          this.getExamResult()
        }, (error) => {
          console.log(error.data);
        })
      },
      modExamResult: async function(result) {
        console.log(result);
        const toJavascriptDateTime = Date.parse(result.exam_time);
        var d = new Date(toJavascriptDateTime);
        const date = d.toLocaleDateString();
        const time = d.toLocaleTimeString();
        this.vib_ikt = result.reg_num
        this.exam_date = date
        this.exam_time = time
        this.exam_place = result.location
        this.exam_type = result.subject
        this.exam_result = result.result
        this.exam_result_id = result.exam_result_id
      },
      getExamObligatory: async function() {
        this.no_exam_creator = ''
        this.no_exam = null
        this.no_exam_desc = ''
        this.exam_fee_creator = ''
        this.exam_fee = null
        this.exam_fee_desc = ''
        this.med_cert_creator = ''
        this.med_cert = null
        this.med_cert_lookup = ''
        this.med_cert_desc = ''
        this.license_creator = ''
        this.license = null
        this.license_desc = ''
        this.no_exam_id= ''
        this.exam_fee_id= ''
        this.med_cert_id= ''
        this.license_id= ''
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/get_exam_obligatory', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.loading = false
          if (response.data['no_exam']) {
            this.no_exam_creator = response.data['no_exam']['creation']
            this.no_exam = response.data['no_exam']['value']
            this.no_exam_desc = response.data['no_exam']['description']
            this.no_exam_id = response.data['no_exam']['id']
          }
          if (response.data['vizsgadij']) {
            this.exam_fee_creator = response.data['vizsgadij']['creation']
            this.exam_fee = response.data['vizsgadij']['value']
            this.exam_fee_desc = response.data['vizsgadij']['description']
            this.exam_fee_id = response.data['vizsgadij']['id']
          }
          if (response.data['orvosi']) {
            this.med_cert_creator = response.data['orvosi']['creation']
            this.med_cert = response.data['orvosi']['value']
            this.med_cert_lookup = response.data['orvosi']['lookup']
            this.med_cert_desc = response.data['orvosi']['description']
            this.med_cert_id = response.data['orvosi']['id']
          }
          if (response.data['jogsi']) {
            this.license_creator = response.data['jogsi']['creation']
            this.license = response.data['jogsi']['value']
            this.license_desc = response.data['jogsi']['description']
            this.license_id = response.data['jogsi']['id']
          }

        }, (error) => {
          console.log(error.data);
        })
      },
      saveExamObligatory: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/save_exam_obligatory', {
          token: this.token,
          contract_id: this.contract_id,
          no_exam: this.no_exam,
          no_exam_desc: this.no_exam_desc,
          exam_fee: this.exam_fee,
          exam_fee_desc: this.exam_fee_desc,
          med_cert: this.med_cert,
          med_cert_lookup: this.med_cert_lookup,
          med_cert_desc: this.med_cert_desc,
          license: this.license,
          license_desc: this.license_desc,
          no_exam_id: this.no_exam_id,
          exam_fee_id: this.exam_fee_id,
          med_cert_id: this.med_cert_id,
          license_id: this.license_id,
          username: this.username
        }).then((response) => {
          this.snackbar = true
          this.loading = false
          this.response_text = response.data;

          this.getExamObligatory()
        }, (error) => {
          console.log(error.data);
        })
      },
      getObLookupList: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/oblookup', {
          token: this.token
        }).then((response) => {
          this.loading = false
          this.oblookup = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      examTypes: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/exam_types', {
          token: this.token
        }).then((response) => {
          this.loading = false
          this.exam_types = response.data['targy']
          this.exam_result_types = response.data['eredmeny']
        }, (error) => {
          console.log(error.data);
        })
      },
      resetValidation () {
        this.$refs.save_exam_form.resetValidation()
      },
      resetVertifForm () {
        this.$refs.valid_form.resetValidation()
      },
    },
    mounted() {
      this.getObLookupList()
      this.examTypes()
    },
    watch: {
      contract_id() {
        if (this.diakok_tab == 3) {
          this.getExamResult()
          this.getExamObligatory()
          this.getBiziResult()
          this.getKokenyExamResults()
          this.getStudIds()
        }
      },
      diakok_tab: function (value) {
        if (value == 3) {
          this.getExamResult()
          this.getExamObligatory()
          this.getBiziResult()
          this.getKokenyExamResults()
        }
      },
      del_exam_picked() {
        this.getExamstoDel()
      },
      selected_stud_id(value) {
        if (value) {
          this.getExamstoDel()
          this.getExamstoVertif()
        }
      }
    },
    computed: {
    ...mapFields([
      'diakok_details.contract_id',
      'diakok_details.customer_id',
      'diakok_details.course_type',
      'auth.username',
      'auth.admin',
      'showing.preloader',
      'exam_details.student_exam_result',
      'diakok_details.diakok_tab',
  ]),
  },
  }
</script>

<style lang="css">
</style>
